<mat-card appearance="outlined" id="autoshipEditor">
  <mat-card-content>
    <div class="fx-col">
      <div class="main fx-row lt-lg-fx-col fx-flex-100-in-col">
        <div class="p-r-15 fx-col lt-lg-fx-flex-49-in-col print-fx-flex-49 gt-md-fx-flex-49">
          <div class="text-uppercase  borderBottom fx-row">
            <div class="color-f-s-14 fx-flex-70">
              <span translate="autoshiip"></span>
              <span [textContent]="''+$safeNavigationMigration(persistentService?.retailData?.CurrentSelectedAutoOrder)"></span>
            </div>
            <div class="text-center color-f-s-14 fx-flex-10" translate="global_pv"></div>
            <div class="text-right color-f-s-14 fx-flex-20" translate="price"></div>
          </div>
          @for (item of itemsService.selectedAutoOrderItems; track item; let i = $index) {
            <div class="items m-t-5 md-no-proxy mx-height-30 _md borderBottom1 fx-row"
              >
              <div class="fx-row fx-flex-70">
                <div class="cart-items__images fx-flex-30">
                  <img class="img-avatar"
                    [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + item.ImageUrl"
                    [default]="'assets/images/noimage.png'">
                  </div>
                  <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-55">
                    <h3 class="product_detail_text itemName" matTooltip="Ignite Plumping Lip Gloss"
                    [textContent]="(item.ItemName || item.ProductName) | slice:0:40"></h3>
                    <span class="product_detail_text" [textContent]="item.selectedOptions"></span>
                    <div class="fx-row">
                      <div class="input-group fx-row fx-main-center fx-cross-center">
                        <span class="input-group-btn">
                          <button mat-button-icon class="" type="button"
                            (click)="cart1Service.decreaseQuantiy(item,true,false)">
                          <mat-icon class="c-gray">remove</mat-icon>
                        </button>
                      </span>
                      <input type="text" class="input-control" maxlength="2"
                        [(ngModel)]="getQuantityModel('autoship',item)[item.ItemID]" validate inputonlynumber="true"
                        (change)="checkQuantity('autoship', item)"
                        (keyup)="($event.which === 38) ? cart1Service.increaseQuantiy(item, true, false) : 0"
                        (keydown)="($event.which === 40) ? cart1Service.decreaseQuantiy(item, true, false) : 0">
                      <span class="input-group-btn">
                        <button mat-button-icon class="" type="button"
                          (click)="cart1Service.increaseQuantiy(item,true,false)">
                          <mat-icon class="c-gray">add</mat-icon>
                        </button>
                      </span>
                    </div>
                    <div class="actionButton fx-row">
                      <!-- Edit item -->
                      <button mat-button class="" waves="circle" type="button"
                        (click)="cart1Service.showProductDetail(item, true, item.HasOptions, false, true)">
                        <mat-icon class="c-gray">edit</mat-icon>
                      </button>
                      <!-- Delete item -->
                      <button mat-button class="" waves="circle" type="button" (click)="deleteItem(item)">
                        <mat-icon class="c-gray">delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fx-row fx-main-center fx-cross-start fx-flex-10">
                <span class="color-f-s-14" [textContent]="item.Quantity * (item.BusinessVolume || item.PV || item.CV || 0)"></span>
              </div>
              <div class="fx-row fx-main-end fx-cross-start fx-flex-20">
                <span class="color-f-s-14" [textContent]="(item.Price | currency: companyService.selectedCurrency.CurrencyCode)"></span>
              </div>
            </div>
          }
          <div class="fx-row">
            <div class="p-t-10 p-b-10 borderBottom1 fx-row fx-flex-100">
              <div class="text-right fx-flex-60"><span translate>sub_total</span>:</div>
              <div class="text-right fx-flex-20">
                <strong>
                  <span class="m-r-15" data-text="discount-total "
                  [textContent]="orderService.autoorderBusinessVolume"></span>
                </strong>
              </div>
              <div class="text-right fx-flex-20">
                <strong>
                  <span data-text="taxtotal"
                  [textContent]="(orderService.calculateAutoOrderResponse.SubTotal | currency: companyService.selectedCurrency.CurrencyCode)"></span>
                </strong>
              </div>
            </div>
          </div>
          <div class="fx-row">
            <div class="p-t-10 p-b-10 fx-row fx-flex-100">
              <div class="text-right fx-flex-60"> {{'global_total'|translate}} :</div>
              <div class="text-right fx-flex-40">
                <strong>
                  <span data-text="subtotal"
                  [textContent]="(orderService.calculateAutoOrderResponse.Total | currency: companyService.selectedCurrency.CurrencyCode)"></span>
                </strong>
              </div>
            </div>
          </div>
        </div>
        <div class="borderLeft lt-lg-fx-flex-2-in-col print-fx-flex-2 gt-md-fx-flex-2">
        </div>
        <div class="padding-t-20 fx-row lt-lg-fx-flex-49-in-col print-fx-flex-49 gt-md-fx-flex-49">
          <div class="fx-col fx-flex-100">
            <div class="borderBottom fx-flex-5-in-col">
              <span class="color-f-s-17" translate="shipping_payment"></span>
            </div>
            <div class="borderBottom1 fx-row fx-flex-95-in-col">
              <div class="m-t-10">
                <mat-icon class="c-gray">access_time</mat-icon>
              </div>
              <div class="flex-grow p-l-15 m-t-10 m-b-10">
                @if (!IsMultipleFrequency) {
                  <div class="f-s-12 c-black87 text-uppercase color-f-s-12"
                  translate="frequency"></div>
                }
                @if (IsMultipleFrequency) {
                  <div class="f-s-12 c-black87 text-uppercase color-f-s-12"
                  translate="Date Picker"></div>
                }
                <!-- <div [textContent]="getAutoshipStartDate() | date: 'MMMM d, yyyy'"><span><mat-icon class="c-gray">edit</mat-icon></span>
              </div> -->
              <div class="fx-row fx-main-start fx-cross-center">
                <div [textContent]="getAutoshipStartDate() | date: 'MMMM d, yyyy'">
                </div>
                <div>
                  <mat-icon class="c-gray cursor-pointer" (click)="picker.open()">edit</mat-icon>
                </div>
              </div>
              @if (!IsMultipleFrequency) {
                <div [textContent]="getAutoshipFrequency() | translate"></div>
              }
              <!-- Multiple Frequency -->
              <div class="fx-row">
                @if (IsMultipleFrequency) {
                  <div class="p-0">
                    <div class="f-s-12 c-black87 text-uppercase p-0 color-f-s-12" translate="frequency"></div>
                    <div class="p-0 fx-row">
                      <mat-form-field class="fx-flex-100">
                        <mat-select frequencychecksection="true" [(ngModel)]="frequencyTypeID"
                          (selectionChange)="setFrequency(frequencyTypeID);" aria-label="frequency">
                          @for (freq of commonData.FrequencyTypes; track freq) {
                            <mat-option [value]="freq.ID" translate="">
                            {{freq.Description | translate}} </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                }
                <div class="fx-row fx-main-center fx-cross-center">
                  <mat-form-field appearance="none" class="fx-flex">
                    <!-- <mat-label fxHide>Choose a date</mat-label> -->
                    <input matInput [matDatepicker]="picker" [(ngModel)]="autoshipConfigurationService.autoshipDate" [min]="AutoshipMinDate"
                      [max]="AutoshipMaxDate" disabled (dateChange)="editAutoshipFrequency($event);" class="fx-hide">
                    <mat-datepicker-toggle style="display: none;" matSuffix [for]="picker">
                      <mat-icon class="c-gray fx-hide" matDatepickerToggleIcon>keyboard_arrow_down </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker disabled="false" [startAt]="autoshipConfigurationService.autoshipDate"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="borderBottom1 fx-row fx-flex-100-in-col">
            <div class="m-t-10 fx-flex-5">
              <mat-icon class="c-gray">local_shipping</mat-icon>
            </div>
            <div class="flex-grow p-l-15 m-t-10 m-b-10 fx-flex-50">
              <div id="shipmethods">
                <div class="f-s-12 c-black87 text-uppercase color-f-s-12" translate="shipping_method"></div>
                <div [textContent]="getShipMethodName()" translate></div>
              </div>
            </div>
            <!-- Edit shipping frequency -->
            <div class="editButton fx-row fx-main-end fx-cross-start fx-flex-45">
              <a class="text-uppercase c-color1 m-t-10" (click)="editAutoshipShippingMethod()"
              translate="global_edit"></a>
            </div>
          </div>
          <div class="borderBottom1 fx-row fx-flex-100-in-col">
            <div class="m-t-10 fx-flex-5">
              <mat-icon class="c-gray"> location_on</mat-icon>
            </div>
            <div class="flex-grow p-l-15 m-t-10 m-b-10 fx-flex-50">
              <h5 class="f-s-12 c-black87 text-uppercase p-0 color-f-s-12" translate="shipping_address_lower"></h5>
              <div class="view-shippingaddress fx-row" flex>
                @if (!isStateRestrict && !utilityService.isEmptyObject(userService.shippingAddress)) {
                  <address class="color-f-s-14"
                    >
                    <span [textContent]="userService.shippingAddress.Street1"></span>
                    <br>
                      <span [textContent]="userService.shippingAddress.Street2"></span>
                      <br>
                        <span [textContent]="userService.shippingAddress.City"></span>
                        <span [textContent]="userService.shippingAddress.Region"></span>
                        <span [textContent]="userService.shippingAddress.PostalCode"></span>
                      </address>
                    }
                  </div>
                </div>
                <!-- Edit shipping frequency -->
                <div class="editButton fx-row fx-main-end fx-cross-start fx-flex-45">
                  @if (isStateRestrict || utilityService.isEmptyObject(userService.shippingAddress)) {
                    <button
                      class="btn bgm-color2 m-l-0 text-uppercase c-color1 m-t-10" mat-button
                    (click)="editAutoshipShippingAddress()">{{'add_address' | translate}}</button>
                  }
                  @if (!isStateRestrict && !utilityService.isEmptyObject(userService.shippingAddress)) {
                    <a class="text-uppercase c-color1 m-t-10"
                    (click)="editAutoshipShippingAddress()" translate="global_edit"></a>
                  }
                </div>
              </div>
              <div class="fx-row fx-flex-100-in-col">
                <div class="m-t-10 fx-flex-5">
                  <mat-icon class="c-gray">credit_card</mat-icon>
                </div>
                <div class="flex-grow p-l-15 m-t-10 m-b-10 fx-col fx-flex-95">
                  <div>
                    <span class="" translate="shop_payment_new"></span>
                  </div>
                  <div class="fx-row">
                    <mat-form-field class="fx-flex">
                      @if (userService.paymentMethods.length > 0 && !userService.isPaymentChanged) {
                        <mat-label
                          [textContent]="getDisplayValue()">
                        </mat-label>
                      }
                      @if (userService.paymentMethods.length == 0) {
                        <mat-label translate="unified_add_payment_method">
                        </mat-label>
                      }
                      <mat-select>
                        <mat-select-trigger>
                          @if (userService.paymentMethods.length > 0) {
                            <span [textContent]="getDisplayValue()"></span>
                          }
                        </mat-select-trigger>
                        @if (paymentService.PaymentTypeResponse['SaveMethods']) {
                          @for (paymentMethod of paymentService.PaymentTypeResponse['SaveMethods']; track paymentMethod) {
                            <mat-option
                              value="Credit Card" (click)="addSavePayment(paymentMethod);" class="c-color1"
                              [attr.merchant_id]="paymentMethod.MerchantId" translate>
                              <mat-icon class="p-r-10">credit_card</mat-icon>
                              <span style="cursor: pointer">
                                <span [textContent]="getPaymentDescription(paymentMethod)"></span>
                                <span> {{'_exp'|translate}}&nbsp;&nbsp; <span
                                [textContent]="paymentMethod.Expires | date:'MM/yyyy'"></span>
                              </span>
                            </span>
                            <span class="multipay__dropdown-list__filler"></span>
                            <button mat-icon-button class="btn-icon btn-icon--small btn-link" (click)="removeCardDetail(paymentMethod);">
                              <mat-icon class="p-r-10">delete</mat-icon>
                            </button>
                          </mat-option>
                        }
                      }
                      @if (paymentService.PaymentTypeResponse['AllowedMethods']) {
                        @for (addpayments of paymentService.PaymentTypeResponse['AllowedMethods']; track addpayments) {
                          <mat-option
                            value="Credit Card" (click)="addSavePayment(addpayments);" class="c-color1"
                            [attr.merchant_id]="addpayments.MerchantId"
                            [innerHTML]="addpayments.DisplayName | paymentTranslate:addpayments.DisplayName" translate>
                          </mat-option>
                        }
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                @if ((paymentService.SelectedPaymentTypes.CanSavePayments == false || paymentService.SelectedPaymentTypes.CanSavePayments == 'false')) {
                  <div class="ds-row__item clearfix m-l-0"
                    >
                    @if (!userService.paymentMethods[0].Redirect) {
                      <span class="ds-row__item clearfix"
                      [innerHTML]="('order_pending') | translate" translate></span>
                    }
                    @if (userService.paymentMethods[0].Redirect) {
                      <span class="ds-row__item clearfix"
                      [innerHTML]="('order_needs_redirect') | translate" translate></span>
                    }
                    <span [innerHTML]="('click_here_payment_inst') | translate">
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footerBottom fx-row lt-md-fx-col xs-fx-main-center sm-fx-main-start xs-fx-cross-center sm-fx-cross-stretch fx-flex-100-in-col"
        >
        <div class="fx-row fx-main-start fx-cross-center lt-md-fx-flex-50-in-col print-fx-flex-50 gt-sm-fx-flex-50">
          <button mat-raised-button (click)="addAutoshipItem()">{{'add_more_items' | translate}}</button>
        </div>
        <div class="lt-md-fx-flex-50-in-col print-fx-flex-50 gt-sm-fx-flex-50">
          <div class="m-t-12 fx-row gt-sm-fx-main-end gt-sm-fx-cross-end">
            @if (this.utilityService.getAutoshipEditFlag()) {
              <button mat-button (click)="cancelAutoship()"
              >{{'cancel_autoship' | translate}}</button>
            }
            @if (autoshipChanged()) {
              <button mat-button [attr.disabled]="isDisabledCreateOrder"
              (click)="updateAutoOrder()">{{'save_' | translate}}</button>
            }
            @if (AutoshipSetting['IsShowDeleteAutoship'] && this.utilityService.getAutoshipEditFlag()) {
              <button mat-button
                (click)="deleteAutoship();">
                <mat-icon>delete</mat-icon>{{"delete_" | translate}}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>